import React from 'react';

const Footer = ({ translations }) => {
  const t = translations;

  return (
    <footer className="relative">
     
      
      {/* Footer Content */}
      <div className="bg-gradient-to-r from-pink-600 to-purple-600 text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            
            {/* Brand Section */}
            <div className="md:col-span-1 text-center md:text-left">
              <div className="flex justify-center md:justify-start mb-4">
                <img 
                  src="logo.png" 
                  alt="Sweet Like Nina Logo" 
                  className="w-16 h-16 rounded-full object-cover shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                />
              </div>
              <h3 className="text-2xl font-bold mb-3">Sweet Like Nina</h3>
              <p className="text-white/90 text-sm leading-relaxed mb-4">
                {t.footerText || "Creating sweet memories with every bite. Bespoke cakes and treats made with love."}
              </p>
              
              {/* Social Links */}
              <div className="flex justify-center md:justify-start space-x-4">
                <a 
                  href="mailto:nina@sweetlikenina.com" 
                  className="group w-12 h-12 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-3"
                  aria-label="Email"
                >
                  <svg className="w-5 h-5 text-white group-hover:text-pink-200 transition-colors" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                  </svg>
                </a>
                <a 
                  href="tel:07751712390" 
                  className="group w-12 h-12 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-3"
                  aria-label="Phone"
                >
                  <svg className="w-5 h-5 text-white group-hover:text-pink-200 transition-colors" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                  </svg>
                </a>
                <a 
                  href="https://wa.me/447751712390" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group w-12 h-12 bg-white/10 hover:bg-green-500/80 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-3"
                  aria-label="WhatsApp"
                >
                  <svg className="w-5 h-5 text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.570-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.facebook.com/share/14vPf1xYrD/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group w-12 h-12 bg-white/10 hover:bg-blue-500/80 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-3"
                  aria-label="Facebook"
                >
                  <svg className="w-5 h-5 text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  href="https://www.tiktok.com/@snaidernina" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group w-12 h-12 bg-white/10 hover:bg-black/80 rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-3"
                  aria-label="TikTok"
                >
                  <svg className="w-5 h-5 text-white transition-colors" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div className="text-center md:text-left">
              <h4 className="text-lg font-semibold mb-4 text-white">Contact Info</h4>
              <div className="space-y-3 text-sm">
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-3">📧</span>
                  <a href="mailto:nina@sweetlikenina.com" className="text-white/90 hover:text-white transition-colors">
                    nina@sweetlikenina.com
                  </a>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-3">📱</span>
                  <a href="tel:07751712390" className="text-white/90 hover:text-white transition-colors">
                    07751 712390
                  </a>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-3">💬</span>
                  <a href="https://wa.me/447751712390" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-white transition-colors">
                    WhatsApp
                  </a>
                </div>
                <div className="flex items-center justify-center md:justify-start">
                  <span className="mr-3">📍</span>
                  <span className="text-white/90">Croydon, England</span>
                </div>
              </div>
            </div>

           

            {/* Quick Links */}
            <div className="text-center md:text-left">
              <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
              <div className="space-y-2 text-sm">
                <a href="#services" className="block text-white/90 hover:text-white hover:translate-x-1 transition-all duration-200">
                  Our Services
                </a>
                <a href="#about" className="block text-white/90 hover:text-white hover:translate-x-1 transition-all duration-200">
                  About Nina
                </a>
                <a href="#contact" className="block text-white/90 hover:text-white hover:translate-x-1 transition-all duration-200">
                  Contact Us
                </a>
                <a href="#faq" className="block text-white/90 hover:text-white hover:translate-x-1 transition-all duration-200">
                  FAQ
                </a>
              </div>
            </div>
          </div>
          
          {/* Divider */}
          <div className="border-t border-white/20 pt-6">
            
            {/* Bottom Section */}
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              
              {/* Copyright */}
              <div className="text-center md:text-left">
                <p className="text-white/80 text-sm">
                  © 2025 Sweet Like Nina. All rights reserved.
                </p>
              </div>
              
              {/* Made with love */}
              <div className="text-center md:text-right">
                <p className="text-white/80 text-sm">
                  Made with ❤️ and lots of sugar by{' '}
                  <a 
                    href="https://www.linkedin.com/in/cosmin-adrian-iurea-0a142b198/" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-semibold hover:text-pink-200 transition-colors duration-200"
                  >
                    Cosmin
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;